module.exports = __webpack_public_path__ + "img/renew-calendar.58015303.svg";